// Game list card, matching the brief's example layout (UC-04).

import type { GameListItem } from '@shared/dto';
import { esc } from './dom';
import { FORMAT_TR, SKILL_TR, skillClass, STATUS_TR, whenShort } from './format';

export function gameCardHtml(item: GameListItem): string {
  const { game, court, distanceKm, spotsLeft } = item;
  const filled = game.participantIds.length;
  const isFull = game.status === 'full' || spotsLeft === 0;
  const pct = Math.min(100, Math.round((filled / game.capacity) * 100));
  const statusBadge =
    game.status === 'cancelled'
      ? `<span class="badge badge--danger">${STATUS_TR.cancelled}</span>`
      : isFull
        ? `<span class="badge">${STATUS_TR.full}</span>`
        : spotsLeft <= 3
          ? `<span class="badge badge--accent">${spotsLeft} kişi aranıyor</span>`
          : '';

  return `
  <a class="gamecard" href="#/game/${esc(game.id)}">
    <div class="gamecard__top">
      <div class="gamecard__when">${esc(whenShort(game.startsAt))}</div>
      <div class="gamecard__dist">${esc(distanceKm)} km</div>
    </div>
    <div class="gamecard__court">${esc(court.name)}</div>
    <div class="gamecard__meta">
      <span class="badge">${FORMAT_TR[game.format]}</span>
      <span class="badge ${skillClass(game.skill)}">${SKILL_TR[game.skill]}</span>
      ${court.indoor ? '<span class="badge">Kapalı</span>' : '<span class="badge">Açık</span>'}
      ${game.visibility === 'private' ? '<span class="badge">🔒 Özel</span>' : ''}
      ${statusBadge}
    </div>
    <div class="gamecard__players">
      <div class="progress"><div class="progress__bar" style="width:${pct}%"></div></div>
      <span class="gamecard__count">${filled}/${game.capacity}</span>
    </div>
  </a>`;
}
